import css from 'styled-jsx/css';

const styles = css`.chart-container {
    width: 100%;
    height: 100%;
    position: relative;
    line-height: 12px; /*Prevents additional height from being added during resize*/
}

.tooltip {
    pointer-events: none;
}
`;

export default styles;